<template>
  <div class="home">
    <div class="home_header">
      <div class="home_header_logo">
        <a href="/jobseeker-home">
          <img class="logo" src="../../../assets/images/hrdesk-logo-dark-beta.png" />
        </a>
      </div>
      <div class="home_header_btn">
        <div class="home_header_btn_apply">
          <router-link to="/jobseeker-signup">
            <div>SIGN UP</div>
          </router-link>
        </div>
        <div class="home_header_btn_login">
          <router-link to="/login">
            <div>LOGIN</div>
          </router-link>
        </div>
      </div>
      <div class="home_header_mobile">
        <div class="home_header_mobile_bars" @click="mobileMenu">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p @click="mobileMenu">MENU</p>
        <div class="home_header_mobile_drop" v-if="mobile">
          <div @click="mobileMenu">
            <router-link to="/jobseeker-signup">
              <div>SIGN UP</div>
            </router-link>
          </div>
          <div @click="mobileMenu">
            <router-link to="/login">
              <div>LOGIN</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="home_banner">
      <div class="home_banner_text">What job do you want?</div>
      <div class="home_banner_input">
        <div>
          <input type="text" placeholder="Type to search for role e.g. chef, hostess, waiter, plumber..."
            v-model="selecteIndustry" />
          <select v-model="selectedState">
            <option value>Select State</option>
            <option v-for="(val, index) in state" :value="val.id" :key="index">{{ val.name }}</option>
          </select>
        </div>
      </div>
      <div class="home_banner_btn" v-if="!btnLoader">
        <div @click="searchJob">Search Jobs</div>
      </div>
      <div class="home_banner_btn" v-if="btnLoader">
        <div>
          <WhiteLoader />
        </div>
      </div>
    </div>
    <div class="home_loader" v-if="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div class="home_instruction" v-if="!pageLoading">
      <span>How to register</span>
      <ul>
        <li>1. Select Role and State</li>
        <li>2. Click “Search”</li>
        <li>3. Click “I am interested”</li>
        <li>4. And we will connect you to your next job</li>
      </ul>
    </div>

    <div class="home_list" v-if="!pageLoading">
      <h4>
        RECENTLY POSTED
        <span>JOBS</span>
      </h4>
      <p v-if="noResult">There are currently no available jobs.</p>
      <p v-if="noSearch">
        Can't find your job? fill this
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdaIQP8X4TZB3GzdrXZ8y4dDMUEhBwR9OjR-0wZTkeM6aJEXw/viewform"
          target="_blank">form</a>
        and we will go in search of one for you.
      </p>

      <div class="desktop">
        <div>
          <div v-for="(val, index) in jobs" :key="index">
            <div class="home_list_name">
              <h3>{{ val.title ? val.title : "" }}</h3>
              <p>
                <font-awesome-icon icon="user" />
                &nbsp;
                {{ val.no_of_slots ? val.no_of_slots : "" }} open slots
              </p>
              <span>
                <font-awesome-icon icon="map-marker-alt" />
                &nbsp;{{ val.state ? val.state.name : "" }}
              </span>
            </div>
            <div class="home_list_amount">
              &#8358;{{
                val.salary
                  ? val.salary
                    .toFixed(2)
                    .toString()
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                  : ""
              }}
            </div>
            <div class="home_list_btn">
              <div>
                <routerLink to="/jobseeker-signup">
                  <div>I am interested</div>
                </routerLink>
              </div>
              <p>
                <font-awesome-icon icon="clock" />
                &nbsp;{{ val.daysLeft }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="mobile">
        <div>
          <div v-for="(val, index) in jobs" :key="index">
            <div class="home_list_mobile_details">
              <h4>{{ val.title ? val.title : "" }}</h4>
              <p>
                (&#8358;{{
                  val.salary
                    ? val.salary
                      .toFixed(2)
                      .toString()
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    : ""
                }})
              </p>
              <span>
                <font-awesome-icon icon="user" />
                &nbsp;
                {{ val.no_of_slots ? val.no_of_slots : "" }} open slots
                <font-awesome-icon icon="map-marker-alt" />
                &nbsp;{{ val.state ? val.state.name : "" }}
              </span>
            </div>
            <div class="home_list_mobile_btn">
              <div>
                <routerLink to="/jobseeker-signup">
                  <div>I am interested</div>
                </routerLink>
              </div>
              <p>
                <font-awesome-icon icon="clock" />
                &nbsp;{{ val.daysLeft }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home_paginate" v-if="!pageLoading">
      <div v-if="this.paginate.lastPage !== 1">
        <div @click="pagination(paginate.firstPageUrl)">
          1
        </div>
        <div @click="pagination(paginate.prevPageUrl)">
          << /div>
            <div>{{ paginate.currentPage }}</div>
            <div @click="pagination(paginate.nextPageUrl)">></div>
            <div @click="pagination(paginate.lastPageUrl)">
              {{ paginate.lastPage }}
            </div>
        </div>
      </div>

      <div class="home_footer">
        <div class="home_footer_top">
          <div>
            <div>
              <img class="logo" src="../../../assets/images/logo.png" />
            </div>
            <p>
              hrdesk strives to reduce the lack of transparency in the HR
              outsourcing industry throught platforms that manage prople,
              processes & performance.
            </p>
            <span>support@hrdesk.com</span>
          </div>
          <div>
            <p>What We Offer</p>
            <ul>
              <li>Payroll & Employee Management</li>
              <li>HR Outsourcing</li>
              <li>Outsourced Bookkeeping</li>
              <li>Health Insurance</li>
            </ul>
          </div>
          <div>
            <p>Resources</p>
            <ul>
              <li>Blog</li>
              <li>Help Center</li>
              <li>Support</li>
            </ul>
          </div>
          <div>
            <p>About hrdesk</p>
            <ul>
              <li>About The Company</li>
              <li>Careers</li>
              <li>Customers</li>
            </ul>
          </div>
        </div>
        <div class="home_footer_btm">
          <div>
            <p>Our Coverage</p>
            <div>
              <div>Ghana</div>
              <div>South Africa</div>
            </div>
            <div>
              <div>Kenya</div>
              <div>Algeria</div>
            </div>
            <div>
              <div>Ethiopia</div>
              <div>Angola</div>
            </div>
            <div>
              <div>Tanzania</div>
              <div>Tunisia</div>
            </div>
            <div>
              <div>Morocco</div>
              <div>Canada</div>
            </div>
            <div>
              <div>USA</div>
              <div></div>
            </div>
          </div>
          <div>
            <p>Nigeria</p>
            <span>
              256 Murtala Muhammed Way,
              <br />Alagomeji-Yaba, Lagos
            </span>
          </div>
          <div>
            <p>United States</p>
            <span>
              772 O'Connor Drive Apt 3305,
              <br />Round Rock Texas 78681
            </span>
          </div>
          <div>
            <div>
              <img class="logo" src="../../../assets/images/facebook-logo.svg" />
            </div>
            <div>
              <img class="logo" src="../../../assets/images/twitter.svg" />
            </div>
            <div>
              <img class="logo" src="../../../assets/images/instagram-logo.svg" />
            </div>
            <div>
              <img class="logo" src="../../../assets/images/linkedin.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "JobseekerHome",
  components: {
    PageLoader,
    WhiteLoader
  },
  data() {
    return {
      pageLoading: true,
      btnLoader: false,
      jobs: [],
      state: [],
      joblist: [],
      selectedState: "",
      selecteIndustry: "",
      noResult: false,
      noSearch: false,
      mobile: false,
      paginate: {
        currentPage: "",
        currentPath: "",
        lastPage: "",
        firstPageUrl: "",
        lastPageUrl: "",
        prevPageUrl: "",
        nextPageUrl: ""
      }
    };
  },
  methods: {
    getJobs(val) {
      let url;
      if (val) {
        url = val;
      } else {
        url = types.GET_JOBS;
      }

      this.paginate.currentPath = url;

      this.$http.get(url).then(resp => {
        this.jobs = [...resp.data.data.data];

        this.paginate.currentPath = resp.data.data.first_page_url;

        this.paginate.firstPageUrl = resp.data.data.first_page_url;
        this.paginate.lastPageUrl = resp.data.data.last_page_url;

        this.paginate.prevPageUrl = resp.data.data.prev_page_url;
        this.paginate.nextPageUrl = resp.data.data.next_page_url;

        this.paginate.currentPage = resp.data.data.current_page;
        this.paginate.lastPage = resp.data.data.last_page;

        for (let index = 0; index < this.jobs.length; index++) {
          const noOfdays = this.calculate(this.jobs[index].expiry_date);
          this.jobs[index].daysLeft = noOfdays;
        }

        if (this.jobs.length === 0) {
          this.noResult = true;
          this.noSearch = false;
        }

        if (this.state.length === 0) {
          this.getState();
        } else {
          this.pageLoading = false;
        }
      });
    },
    pagination(val) {
      if (val !== this.paginate.currentPath) {
        if (val) {
          this.pageLoading = true;
          this.getJobs(val);
        }
      }
    },
    getState() {
      this.$http.get(types.GET_STATE).then(resp => {
        this.state = [...resp.data.data];
        this.getJobRoles();
      });
    },
    getJobRoles() {
      this.$http.get(types.GET_JOB_ROLES).then(resp => {
        this.joblist = [...resp.data.data];

        this.pageLoading = false;
      });
    },
    searchJob() {
      if (this.selectedState && this.selecteIndustry) {
        this.btnLoader = true;
        this.$http
          .post(types.SEARCH_JOBS, {
            search_key: this.selecteIndustry,
            state_id: this.selectedState
          })
          .then(resp => {
            this.jobs = [...resp.data.data];

            if (this.jobs.length === 0) {
              this.noResult = false;
              this.noSearch = true;
            }

            this.pageLoading = false;
            this.btnLoader = false;
          });
      }
    },
    mobileMenu() {
      this.mobile = !this.mobile;
    },
    calculate(val) {
      const oneDay = 24 * 60 * 60 * 1000;

      let today = new Date();
      let toDayYear = today.getUTCFullYear();
      let toDayMonth = today.getMonth();
      let toDayDate = today.getDate();
      let setDate = val;
      let num = setDate.split("-");
      let setYear = num[0];
      let setMonth = num[2] - 1;
      let setDay = num[1];

      const firstDate = new Date(toDayYear, toDayMonth, toDayDate);
      const secondDate = new Date(setYear, setMonth, setDay);

      if (firstDate > secondDate) {
        return "Job closed";
      }
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

      console.log(diffDays + "");

      if (diffDays + "".length === 7) {
        return "1 week left";
      }

      if (diffDays + "".length === 14) {
        return "2 weeks left";
      }

      if (diffDays + "".length === 21) {
        return "3 weeks left";
      }

      return `${diffDays} days left`;
    }
  },

  created() {
    this.getJobs();
  }
};
</script>

<style lang="scss" scoped>
.home {
  >.home_header {
    height: 80px;
    padding: 0 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;

    @media (max-width: 700px) {
      padding: 0 10px;
    }

    >.home_header_logo {
      max-width: 150px;
    }

    >.home_header_btn {
      width: 270px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;

      @media (max-width: 500px) {
        display: none;
      }

      .home_header_btn_apply {
        width: 150px;
        border-radius: 40px;
        border: solid 1px #707070;
        background-color: #ffffff;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.46;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        cursor: pointer;
        overflow: hidden;

        >a {
          color: #000;
          text-decoration: none;

          >div {
            color: #000000;
            width: 150px;
            padding: 8px 0;
          }
        }
      }

      .home_header_btn_login {
        width: 100px;
        border-radius: 40px;
        border: solid 1px #707070;
        background-color: #ffffff;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.46;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        cursor: pointer;
        overflow: hidden;

        >a {
          color: #000;
          text-decoration: none;

          >div {
            color: #000000;
            width: 100px;
            padding: 8px 0;
          }
        }
      }
    }

    >.home_header_mobile {
      width: 80px;
      // display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      position: relative;
      display: none;

      @media (max-width: 500px) {
        display: flex;
      }

      >p {
        width: 50px;
        font-size: 14px;
        margin: 0;

        font-weight: normal;

        font-stretch: normal;

        font-style: normal;

        line-height: 1.21;

        letter-spacing: normal;

        text-align: left;

        color: #707070;
      }

      >.home_header_mobile_bars {
        width: 50px;

        >div {
          width: 90%;
          height: 5px;
          margin: 2px 0;
          border-radius: 4px;
          background-color: #707070;
        }
      }

      >.home_header_mobile_drop {
        position: absolute;
        top: 25px;
        left: -20px;
        width: 100px;
        padding: 10px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 1px 1px #000;

        >div {
          background-color: #ffffff;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.46;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          cursor: pointer;

          >a {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.46;
            letter-spacing: normal;
            color: #000000;
            text-decoration: none;

            >div {
              width: 100%;
              padding: 10px 0;
            }
          }
        }
      }
    }
  }

  >.home_banner {
    background-image: linear-gradient(to bottom, #f79320, #fcc379 80%, #ffe7bd);
    padding: 100px 0;

    >.home_banner_text {
      font-size: 20px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.1;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      padding: 0 10px;
    }

    >.home_banner_input {
      margin-top: 40px;
      padding: 0 10px;

      >div {
        max-width: 600px;
        margin: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;
        overflow: hidden;

        @media (max-width: 500px) {
          flex-direction: column;
          flex-wrap: wrap;
        }

        >input {
          width: 65%;
          max-width: 400px;
          height: 50px;
          outline: 0;
          padding: 0 5px;
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.17;
          letter-spacing: normal;
          color: #000000;
          border-radius: 5px;
          box-shadow: 0 10px 4px 0 rgba(0, 0, 0, 0.1);
          border: solid 1px rgba(199, 199, 199, 0.4);
          background-color: #ffffff;
          margin-top: 10px;

          @media (max-width: 500px) {
            width: 100%;
          }
        }

        >select {
          width: 34%;
          max-width: 400px;
          height: 50px;
          outline: 0;
          padding: 0 5px;
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.17;
          letter-spacing: normal;
          color: #000000;
          border-radius: 4px;
          box-shadow: 0 10px 4px 0 rgba(0, 0, 0, 0.1);
          border: solid 1px rgba(199, 199, 199, 0.4);
          background-color: #ffffff;
          overflow: hidden;
          margin-top: 10px;

          @media (max-width: 500px) {
            width: 100%;
          }
        }
      }
    }

    >.home_banner_btn {
      max-width: 400px;
      padding: 0 10px;
      margin: 20px auto 0 auto;

      >div {
        width: 200px;
        max-width: 400px;
        height: 40px;
        border-radius: 5px;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        background-color: #5099de;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.18;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        margin: auto;
        cursor: pointer;

        @media (max-width: 500px) {
          width: 100%;
        }
      }
    }
  }

  >.home_loader {
    padding-top: 30px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    align-content: center;
    min-height: 200px;

    >div {
      width: 55px;
    }
  }

  >.home_instruction {
    border-bottom: 1px solid #ccc;
    text-align: center;
    padding: 50px 0 20px 0;

    >span {
      font-size: 20px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.27;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      text-decoration: underline;
    }

    >ul {
      list-style-type: none;
      margin: 0;
      padding: 0;

      >li {
        font-size: 14px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.15;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        padding: 10px 0;
      }
    }
  }

  >.home_list {
    margin: 80px 0;
    min-height: 200px;

    >h4 {
      font-size: 30px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.78;
      letter-spacing: normal;
      text-align: center;
      color: #000;

      >span {
        font-weight: 600;
      }
    }

    >p {
      text-align: center;
      font-size: 14px;
      color: #000;
      margin-top: 20px;
    }

    >.desktop {
      margin-top: 10px;
      padding: 10px;
      overflow: auto;

      @media (max-width: 500px) {
        display: none;
      }

      >div {
        >div {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          border-radius: 2px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
          border: solid 1px #dddddd;
          background-color: #ffffff;
          padding: 20px 10px;
          width: 100%;
          max-width: 800px;
          margin: 50px auto 0 auto;

          >.home_list_name {
            width: 33.3333333%;

            >h3 {
              font-size: 14px;

              font-weight: bold;

              font-stretch: normal;

              font-style: normal;

              line-height: 1.36;

              letter-spacing: normal;

              text-align: left;

              color: #000000;
            }

            >p {
              font-size: 12px;

              font-weight: 300;

              font-stretch: normal;

              font-style: normal;

              line-height: 1.27;

              letter-spacing: normal;

              text-align: left;

              color: #000000;
              margin: 5px 0;
            }

            >span {
              font-size: 12px;

              font-weight: 300;

              font-stretch: normal;

              font-style: normal;

              line-height: 1.27;

              letter-spacing: normal;

              text-align: left;

              color: #000000;
            }
          }

          >.home_list_amount {
            width: 33.3333333%;
            font-size: 16px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #f79320;
          }

          >.home_list_btn {
            width: 33.3333333%;

            >div {
              width: 80%;
              max-width: 200px;
              border-radius: 5px;
              box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
              background-color: #f79320;
              font-size: 13px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 2.22;
              letter-spacing: normal;
              text-align: center;
              color: #ffffff;
              margin: auto;
              overflow: hidden;
              margin-bottom: 10px;

              >a {
                color: #ffffff;
                text-decoration: none;

                >div {
                  width: 100%;
                  height: 40px;
                  display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: center;
                  align-content: center;
                }
              }
            }

            >p {
              font-size: 14px;
              font-weight: bold;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.33;
              letter-spacing: normal;
              text-align: center;
              margin: 0;
              color: #f17d6b;
            }
          }
        }
      }
    }

    >.mobile {
      margin-top: 10px;
      padding: 10px;
      overflow: auto;
      display: none;

      @media (max-width: 500px) {
        display: block;
      }

      >div {
        >div {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          border-radius: 2px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
          border: solid 1px #dddddd;
          background-color: #ffffff;
          padding: 20px 10px;
          width: 100%;
          margin: 50px auto 0 auto;

          >.home_list_mobile_details {
            width: calc(100% - 200px);

            @media (max-width: 450px) {
              width: 50%;
            }

            >h4 {
              font-size: 15px;
              font-weight: bold;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.33;
              letter-spacing: normal;
              color: #000000;
            }

            >p {
              font-size: 16px;
              font-weight: 600;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.17;
              letter-spacing: normal;
              text-align: left;
              color: #f79320;
              margin: 5px 0;
            }

            >span {
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.22;
              letter-spacing: normal;
              text-align: left;
              color: #777;
            }
          }

          >.home_list_mobile_btn {
            width: 200px;

            @media (max-width: 450px) {
              width: 50%;
            }

            >div {
              width: 90%;
              border-radius: 5px;
              box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
              background-color: #f79320;
              font-size: 13px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 2.22;
              letter-spacing: normal;
              text-align: center;
              color: #ffffff;
              margin: auto;
              overflow: hidden;
              margin-bottom: 10px;

              >a {
                color: #ffffff;
                text-decoration: none;

                >div {
                  width: 100%;
                  height: 40px;
                  display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: center;
                  align-content: center;
                }
              }
            }

            >p {
              font-size: 14px;
              font-weight: bold;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.33;
              letter-spacing: normal;
              text-align: center;
              margin: 0;
              color: #f17d6b;
            }
          }
        }
      }
    }
  }

  >.home_paginate {
    margin-bottom: 100px;

    >div {
      width: 300px;
      margin: auto;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-content: center;
      align-items: center;
      overflow: hidden;

      >div {
        width: 20%;
        height: 40px;
        border: 1px solid #ccc;
        cursor: pointer;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        color: #777777;
      }
    }
  }

  >.home_footer {
    margin-bottom: 50px;
    width: 80%;
    margin: 0 auto 50px auto;

    >.home_footer_top {
      border-bottom: 1px solid #ccc;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: center;
      align-content: center;

      >div:nth-child(1) {
        width: 40%;
        margin-bottom: 50px;

        @media (max-width: 1000px) {
          width: 50%;
        }

        @media (max-width: 400px) {
          width: 100%;
        }

        >div {
          max-width: 150px;
        }

        >p {
          max-width: 400px;
          font-size: 12px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          margin: 10px 0;
          padding-right: 10px;
        }

        >span {
          font-size: 12px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #f79320;
        }
      }

      >div:nth-child(2) {
        width: 20%;
        margin-bottom: 50px;

        @media (max-width: 1000px) {
          width: 50%;
        }

        @media (max-width: 400px) {
          width: 100%;
        }

        >p {
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          margin: 0 0 10px 0;
        }

        >ul {
          list-style-type: none;
          margin: 0;
          padding: 0;

          >li {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            padding: 5px 0;
          }
        }

        >span {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          padding: 5px 0;
        }
      }

      >div:nth-child(3) {
        width: 20%;
        margin-bottom: 50px;

        @media (max-width: 1000px) {
          width: 50%;
        }

        @media (max-width: 400px) {
          width: 100%;
        }

        >p {
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          margin: 0 0 10px 0;
        }

        >ul {
          list-style-type: none;
          margin: 0;
          padding: 0;

          >li {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            padding: 5px 0;
          }
        }

        >span {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          padding: 5px 0;
        }
      }

      >div:nth-child(4) {
        width: 20%;
        margin-bottom: 50px;

        @media (max-width: 1000px) {
          width: 50%;
        }

        @media (max-width: 400px) {
          width: 100%;
        }

        >p {
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          margin: 0 0 10px 0;
        }

        >ul {
          list-style-type: none;
          margin: 0;
          padding: 0;

          >li {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            padding: 5px 0;
          }
        }

        >span {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          padding: 5px 0;
        }
      }
    }

    >.home_footer_btm {
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: center;
      align-content: center;

      >div:nth-child(1) {
        width: 40%;
        margin-bottom: 50px;

        @media (max-width: 1000px) {
          width: 50%;
        }

        @media (max-width: 400px) {
          width: 100%;
        }

        >p {
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          margin: 0 0 10px 0;
        }

        >div {
          max-width: 250px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: flex-start;
          justify-content: center;
          align-content: center;
          padding-bottom: 10px;

          >div {
            width: 50%;
            font-size: 12px;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }
        }
      }

      >div:nth-child(2) {
        width: 20%;
        margin-bottom: 50px;

        @media (max-width: 1000px) {
          width: 50%;
        }

        @media (max-width: 400px) {
          width: 100%;
        }

        >p {
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          margin: 0 0 10px 0;
        }

        >ul {
          list-style-type: none;
          margin: 0;
          padding: 0;

          >li {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            padding: 5px 0;
          }
        }

        >span {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          padding: 5px 0;
        }
      }

      >div:nth-child(3) {
        width: 20%;
        margin-bottom: 50px;

        @media (max-width: 1000px) {
          width: 50%;
        }

        @media (max-width: 400px) {
          width: 100%;
        }

        >p {
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          margin: 0 0 10px 0;
        }

        >ul {
          list-style-type: none;
          margin: 0;
          padding: 0;

          >li {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            padding: 5px 0;
          }
        }

        >span {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          padding: 5px 0;
        }
      }

      >div:nth-child(4) {
        width: 20%;
        margin-bottom: 50px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: flex-start;
        align-content: center;

        @media (max-width: 1000px) {
          width: 50%;
        }

        @media (max-width: 400px) {
          width: 100%;
        }

        >div {
          width: 20px;
          cursor: pointer;

          >img {
            width: 10px;
          }
        }
      }
    }
  }
}
</style>
